import Vue from 'vue'
import VueRouter from 'vue-router'
import { getCurrentUser } from '../api/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'ScreenLogin',
    component: () => import('../views/ScreenLogin.vue')
  },
  {
    path: '/',
    name: 'DataScreen',
    component: () => import('../views/DataScreen.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/portrait',
    name: 'CountyPortrait',
    component: () => import('../views/CountyPortrait.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/command',
    name: 'EmergencyCommand',
    component: () => import('../views/EmergencyCommand.vue'),
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach(async (to, from, next) => {
  if (!to.meta.requiresAuth) {
    if (to.path === '/login') {
      try {
        const res = await getCurrentUser()
        if (res && (res.code === 200 || res.code === 0)) {
          next('/')
          return
        }
      } catch (e) {
        console.debug('screen login check skipped', e && e.message)
      }
    }
    next()
    return
  }

  try {
    const res = await getCurrentUser()
    if (res && (res.code === 200 || res.code === 0)) {
      next()
      return
    }
  } catch (e) {
    console.debug('screen auth check failed', e && e.message)
  }

  next('/login')
})

export default router
